// ADENDA z52-1 (Diego, 28-oct-2026; caso SX-2026-0031, restaurante con recibo 1F): un NEGOCIO (comercio o industria) cuyo
// recibo es de casa (1, 1A–1F o DAC) se calcula «todo a futuro» con la tarifa comercial que le pone CFE al conectar paneles:
// PDBT (o GDBT si el vendedor la escogió en el cuestionario porque su carga pasa de 25 kW). Pagaría sin paneles, con paneles,
// ahorro, retorno, 25 años, FINSUS y deducción salen todos en esa tarifa; el recibo de casa solo se imprime en una línea y
// nunca se resta de una cifra en PDBT. UNA sola regla: el motor, la revisión de la lectura y el PDF la leen de aquí.
import { TARIFAS_CASA } from './basicos.ts';
import type { Tarifa } from './basicos.ts';
import type { Cuestionario } from './cuestionario.ts';

export interface CambioTarifa {
  /** La tarifa del recibo (de casa). */
  de: Tarifa;
  /** La tarifa con la que se calcula todo a futuro. */
  a: 'PDBT' | 'GDBT';
}

/** ADENDA z52-1. null = se calcula con la tarifa del recibo, como siempre. `prendido` = el parámetro de versión
 *  `negocio_a_pdbt` de la cotización (nace solo en comercio e industria nuevas; las guardadas no cambian solas).
 *  Dos medidores: null (siguen la regla H-4 y su rojo). GDBT solo si el vendedor la escogió (el recibo de casa no trae demanda). */
export function cambioDeTarifa(c: Pick<Cuestionario, 'tipo' | 'tarifa' | 'dos_medidores'>, leida: Tarifa | null, prendido: boolean): CambioTarifa | null {
  if (!prendido || !leida) return null;
  if (c.tipo !== 'comercio' && c.tipo !== 'industria') return null;
  if (!(TARIFAS_CASA as readonly string[]).includes(leida)) return null;
  if (c.dos_medidores) return null;
  return { de: leida, a: c.tarifa === 'GDBT' ? 'GDBT' : 'PDBT' };
}

/** Lo que dice la nota de la portada y el aviso: «tarifa 1F (de casa)». */
export function nombreTarifaCasa(t: Tarifa): string {
  return t === 'DAC' ? 'tarifa DAC (de casa)' : `tarifa ${t} (de casa)`;
}
